import React, { useCallback } from "react";
import styled from "styled-components";

const StyledLink = styled.span`
  color: #027ee0;
  cursor: pointer;
  text-decoration: underline;
  font-size: 13px;
`;

const UnAuthContainer = styled.div`
    padding-left: 15px;
    padding-top: 15px;
`;

const UserNotAuthorized = () => {
  const onClickHome = useCallback(() => {
    window.location.href = `${window.location.origin}/TracerEnsemble/HomePage.aspx`;
  }, []);

  return (
    <UnAuthContainer>
      <div>
        <h4>Page Not Available</h4>
        <p>
          This page is not available based upon your user permissions. Contact
          your system administrator if you should have access to this page.
        </p>
        <p>
          You can go to any portion of the site by using the links at the top of
          the page, or by selecting one of the following links.
        </p>
        <div>
          <StyledLink onClick={onClickHome}>Tracer Ensemble Home</StyledLink>
        </div>
        <div>
          <StyledLink onClick={onClickHome}>My Home</StyledLink>
        </div>
      </div>
    </UnAuthContainer>
  );
};

export default UserNotAuthorized;
